import { User } from "firebase/auth";

export const isAnonymous = (authUser?: User | null) => {
  if (!authUser) return true;
  return authUser.isAnonymous;
};
